import type { ComponentPropsWithoutRef } from 'react'
import { useContext } from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import ToggleButton from 'LuxKit/ToggleButton'
import AIGlowRing from 'components/Common/AIGlowRing'
import AIGlowHighlightContext from 'contexts/aiGlowHighlightContext'

const RING_REPLACES_BORDER_CLASS = 'ai-glow-replaces-border'

/*
 * `display: grid` keeps the button stretching to its grid cell exactly as it did
 * before the wrapper existed. The tripled class beats ToggleButton's own
 * `.kind-secondary.is-selected` border, which would otherwise double up with the ring.
 */
const Cell = styled.div`
  position: relative;
  display: grid;
  border-radius: ${props => props.theme.borderRadius.M};

  &&& .${RING_REPLACES_BORDER_CLASS} {
    border-color: transparent;
    box-shadow: none;
  }
`

type Props = ComponentPropsWithoutRef<typeof ToggleButton>

function AIGlowToggleButton(props: Props) {
  const { className, ...toggleButtonProps } = props
  const isAIGlowHighlighted = useContext(AIGlowHighlightContext)
  const isGlowing = isAIGlowHighlighted && !!props.isSelected

  return (
    <Cell>
      <ToggleButton
        {...toggleButtonProps}
        className={clsx(className, { [RING_REPLACES_BORDER_CLASS]: isGlowing })}
      />
      {isGlowing && <AIGlowRing data-testid="ai-glow-toggle-ring" />}
    </Cell>
  )
}

export default AIGlowToggleButton
